import { useEffect, useRef, useState } from 'react';
import { Avatar } from '@WESCO-International/wdp-ui-components/components/avatar';
import { useRole } from '../../../../../plugins/ifs-catalog/src/role/RoleContext';

export const oneLevelMenuData = {
  label: 'One Level',
  items: [
    { label: 'My Profile' },
    { label: 'Documentation' },
    { label: 'Help and Support' },
    { label: 'Preferences', divider: true },
    { label: 'Logout' },
  ],
};

export default function RightNavContent() {
  const { role, setRole, toggleRole } = useRole();
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const handleSelectRole = (next: 'Employee' | 'Admin') => {
    setRole(next);
    setOpen(false);
  };

  return (
    <div className="flex">
      <div className="flex center mr-3 fs-0" id="feature6" ref={menuRef}>
        <div
          className="flex center clickable"
          onClick={() => setOpen(o => !o)}
          style={{ position: 'relative' }}
        >
          <div className="size-7">
            <Avatar
              initials={role === 'Admin' ? 'AD' : 'EM'}
              size="small"
              className="fs-0"
              variant="primary"
            />
          </div>
        </div>
        <div style={{ marginLeft: 8, fontSize: 12, color: '#4b5563' }}>
          {role}
        </div>
        {open && (
          <div
            style={{
              position: 'absolute',
              right: 0,
              top: '100%',
              marginTop: 8,
              background: '#fff',
              boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
              borderRadius: 8,
              padding: '8px 0',
              minWidth: 180,
              zIndex: 10,
            }}
          >
            <div
              style={{
                padding: '8px 14px',
                fontWeight: 600,
                fontSize: 12,
                color: '#6b7280',
                letterSpacing: 0.2,
              }}
            >
              Switch Role
            </div>
            <button
              type="button"
              onClick={() => handleSelectRole('Employee')}
              style={{
                width: '100%',
                textAlign: 'left',
                padding: '10px 14px',
                background: role === 'Employee' ? '#eef2ff' : 'transparent',
                border: 'none',
                color: '#111827',
                cursor: 'pointer',
              }}
            >
              Employee
            </button>
            <button
              type="button"
              onClick={() => handleSelectRole('Admin')}
              style={{
                width: '100%',
                textAlign: 'left',
                padding: '10px 14px',
                background: role === 'Admin' ? '#eef2ff' : 'transparent',
                border: 'none',
                color: '#111827',
                cursor: 'pointer',
              }}
            >
              Admin
            </button>
            <button
              type="button"
              onClick={toggleRole}
              style={{
                width: '100%',
                textAlign: 'left',
                padding: '10px 14px',
                borderTop: '1px solid #e5e7eb',
                background: 'transparent',
                border: 'none',
                color: '#2563eb',
                cursor: 'pointer',
              }}
            >
              Toggle Role
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
